import { createStore, applyMiddleware } from "redux";
import { combineReducers } from "redux";
import popoverReducer from "./reducer";
import workspaceReduser from "./workspaceReducer";
import chatReducer from "./chatReducer";
import trackerReducer from "./tracker";
import thunk from "redux-thunk";
import { compose } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import { ChatSliceReducer } from "./chat/chatSlice";
import { NotificationReducer } from "./notifications/notificationSlice";
import { ChartSliceReducer } from "./charts/chartSlice";
import { DataAlertReducer } from "./dataAlerts/dataAlertsSlice";
import { TrackerSliceReducer } from "./trackers/trackerSlice";
import { TutorialsSliceReducer } from "./tutorials/tutorials.slice";
import wsProgress from "./wsProgress/wsProgress";
import { temporaryWorkspaceReducer } from "./temporaryWorkspase/temporaryWorkspace";
import { Connections } from "./connections/connSlice";
import { DataFetchingReducer } from "./dataFetchingProgress/dataFetchingProgress";
import { AccessTokens } from "./accessTokens/accessTokens";
import { DashboardDatapieces } from "./dashboardDatapieces/dashboardDatapieces";
import { decisionHubReducer } from "./decisionHub/decisionHub";
import { goalsIdeasMovesReducer } from "./goalsIdeasMoves/goalsIdeasMoves";
import { configReducer } from "./config/config";
import { financeStatementReducer } from "./financeStatement/financeStatement";
import { underwritingReducer } from "./underwriting/underwriting";
import { temporaryDashboardReducer } from "./temporaryDashboard/temporaryDashboard";
import { credentialVerificationReducer } from "./credentialVerification/credentialVerification";
import { agencyConfigReducer } from "./agencyConfig/agencyConfig";
import { agencydashboardReducer } from "./agencyDashboard/agencyDashboardSlice";
import { gstReconReducer } from "./gstRecon/gstReconSlice";

export const store = configureStore({
  reducer: {
    dashboardDatapieces: DashboardDatapieces,
    accessTokens: AccessTokens,
    connections: Connections,
    chatState: ChatSliceReducer,
    notificationState: NotificationReducer,
    trackerState: TrackerSliceReducer,
    dataAlertState: DataAlertReducer,
    chartState: ChartSliceReducer,
    popover: popoverReducer,
    workspace: workspaceReduser,
    chat: chatReducer,
    tracker: trackerReducer,
    tutorials: TutorialsSliceReducer,
    wsProgress: wsProgress,
    temporaryWorkspace: temporaryWorkspaceReducer,
    dataFetchingProgress: DataFetchingReducer,
    decisionHub: decisionHubReducer,
    goalsIdeasMoves: goalsIdeasMovesReducer,
    config: configReducer,
    financeStatement: financeStatementReducer,
    underwriting: underwritingReducer,
    temporaryDashboard: temporaryDashboardReducer,
    credentialVerification: credentialVerificationReducer,
    agencyConfig: agencyConfigReducer,
    agencyDashboard: agencydashboardReducer,
    gstRecon: gstReconReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  devTools: import.meta.env.NODE_ENV !== "production",
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

// const rootReducer = combineReducers({
//   popover: popoverReducer,
//   workspace: workspaceReduser,
//   chat: chatReducer,
//   tracker: trackerReducer,
// });

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// const store = createStore(
//   rootReducer,
//   composeEnhancers(applyMiddleware(thunk))
// );

// export default store;
